module.exports = __webpack_public_path__ + "static/media/minus.e03d843c.svg";